import { InfluencerService } from '../../../services/influencer/influencer.service';
import { CommonConstant, kpiAttributes, listOrderedPlatforms, pieChartConfig } from '../../../app.constants';
import { ActivatedRoute } from '../../../../../node_modules/@angular/router';
import { UserService } from '../../../services/user.service';
import { ReferenceDataService } from '../../../services/reference-data/reference-data.service';
import 'rxjs/add/observable/interval';
import { PdfExportService } from '../../../services/export-pdf/pdf-export.service';
import { DemographicComponent } from '../../influencer/demographic/demographic.component';
import { TranslateService } from '@ngx-translate/core';
import { PostListComponent } from '../../influencer/post-list/post-list.component';
import { Observable } from 'rxjs/Observable';
import { DateUtils } from '../../../utils/date.utils';
import { AppSettings } from '../../../utils/app-settings';
export var ServiceCounter;
(function (ServiceCounter) {
    ServiceCounter[ServiceCounter["init"] = 0] = "init";
    ServiceCounter[ServiceCounter["max"] = 10] = "max";
    ServiceCounter[ServiceCounter["renderTimeout"] = 500] = "renderTimeout";
})(ServiceCounter || (ServiceCounter = {}));
export var LIMIT;
(function (LIMIT) {
    LIMIT[LIMIT["LIMIT_10"] = 10] = "LIMIT_10";
    LIMIT[LIMIT["LIMIT_20"] = 20] = "LIMIT_20";
})(LIMIT || (LIMIT = {}));
var InfluencerDetailPdfViewerComponent = /** @class */ (function () {
    function InfluencerDetailPdfViewerComponent(influencerService, route, userService, referenceDataService, pdfExportService, translate) {
        this.influencerService = influencerService;
        this.route = route;
        this.userService = userService;
        this.referenceDataService = referenceDataService;
        this.pdfExportService = pdfExportService;
        this.translate = translate;
        this.platformList = [];
        this.topExposures = [];
        this.bestPerformingExposures = [];
        this.listPlatformReach = [];
        this.selectedDemographicSource = {
            name: null,
            platformName: null
        };
        this.pieChartCenter = [];
        this.channelFollower = [];
        // channel followers
        this.channelFollowersData = [];
        this.isEnableChannelFollowers = false;
    }
    InfluencerDetailPdfViewerComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.isEnableChannelFollowers = AppSettings.isEnableChannelFollowers();
        // disable highchart animation
        var highcharts = require('highcharts');
        highcharts.setOptions({
            chart: {
                animation: false
            },
            plotOptions: {
                series: {
                    animation: false
                }
            }
        });
        // load report data
        Observable.combineLatest(this.route.params, this.route.queryParams).subscribe(function (_a) {
            var res1 = _a[0], res2 = _a[1];
            _this.influencerId = res1.id;
            _this.activeChannel = res2.insightChannel ? Number(res2.insightChannel) : null;
            if (res2.insightChannel) {
                _this.getChannelFollowers(_this.influencerId, _this.activeChannel);
            }
            else if (res2.channelFollower) {
                _this.channelFollower = res2.channelFollower.indexOf(',') >= 0 ? res2.channelFollower.split(',').map(Number) : Number(res2.channelFollower);
                _this.getChannelFollowers(_this.influencerId, _this.channelFollower);
            }
            else {
                _this.getChannelFollowers(_this.influencerId, null);
            }
            // get topic data
            _this.isVisibleTopicChart = false;
            _this.influencerService.checkInfluencerCreditAvailability(_this.influencerId, _this.userService.getCompanyId());
            // load influencer details
            _this.getInfluencerDetails(_this.influencerId);
            // get post list
            _this.getInfluencerPosts(_this.influencerId, _this.activeChannel);
            _this.getPeformanceReportTimeLineChart(_this.influencerId, _this.activeChannel);
            // load platform reach table data
            _this.getPlatformReachTable(_this.influencerId, _this.activeChannel);
            _this.getExposures(_this.influencerId, _this.activeChannel);
            _this.getBestPerforming(_this.influencerId, _this.activeChannel);
        });
        this.platformList = this.referenceDataService.platforms;
        this.pdfExportService.triggerIncrementReportReady.subscribe(function (numberReportReady) {
            if (numberReportReady === ServiceCounter.max && _this.influencerService.isCreditAvailable() === true) {
                console.log(' ***************************************** INFLUENCER READY TO EXPORT PDF *****************************************');
                setTimeout(function () {
                    _this.pdfReady();
                    // mark influencer as visited
                    _this.influencerService.visitInfluencer(_this.influencerId, _this.userService.getCompanyId()).subscribe();
                }, ServiceCounter.renderTimeout);
            }
        });
        this.currentDate = DateUtils.now();
        this.previousDate = DateUtils.addPerid(this.currentDate, -CommonConstant.PERIOD_30_DAYS);
        this.loadPieChartStyling();
    };
    InfluencerDetailPdfViewerComponent.prototype.getSupportedPlatformReachIdList = function (platformReachs) {
        return platformReachs.map(function (pr) {
            var platform = listOrderedPlatforms.find(function (p) { return p.name.toLowerCase() === pr.name.toLowerCase(); });
            return platform ? platform.id : null;
        });
    };
    InfluencerDetailPdfViewerComponent.prototype.pdfReady = function () {
        if (window && typeof window.pdfReady === 'function') {
            setTimeout(function () {
                window.pdfReady();
            }, ServiceCounter.renderTimeout);
        }
    };
    InfluencerDetailPdfViewerComponent.prototype.getInfluencerDetails = function (influencerId) {
        var _this = this;
        this.influencerService.getInfluencer(influencerId).subscribe(function (data) {
            _this.influencer = data;
            var activeChannel = _this.activeChannel && _this.activeChannel > 0 ? {
                id: _this.activeChannel
            } : null;
            _this.influencerKPIData = _this.influencerService.normalizeChannelAverageKpi(data.channelAverageKpis, data.average, activeChannel);
            if (data.platformReaches) {
                var calculatedPlatformReachsData = _this.influencerService.calculatePlatformReach(data.platformReaches);
                _this.platformReachs = calculatedPlatformReachsData.platformReachs;
            }
            _this.popularTopic = new Array();
            _this.topicAndEngagementChart = new Array();
            if (_this.influencer && Array.isArray(_this.influencer.topTopics)) {
                _this.influencer.topTopics.forEach(function (topic) {
                    if (topic.name !== 'NA' && Math.round(topic.percent * 1000) / 10 !== 0) {
                        _this.popularTopic.push({ name: topic.name, y: topic.percent });
                    }
                    if (topic.name !== 'NA' && Math.round(topic.engagement * 1000) / 10 !== 0) {
                        _this.topicAndEngagementChart.push({ name: topic.name, y: topic.engagement });
                    }
                });
            }
            _this.isVisibleTopicChart = _this.influencer.topTopics != null && _this.influencer.topTopics.length > 0;
            // extract top mention list
            _this.topMention = new Array();
            if (_this.influencer && Array.isArray(_this.influencer.topMentions)) {
                _this.influencer.topMentions.forEach(function (mention) {
                    _this.topMention.push({
                        keyword: mention.mention,
                        number: mention.count,
                    });
                });
            }
        });
    };
    InfluencerDetailPdfViewerComponent.prototype.getInfluencerPosts = function (influencerId, channelId) {
        var _this = this;
        var postListParams = {
            orderBy: kpiAttributes.engagement,
            limit: CommonConstant.LIMIT_20,
        };
        if (channelId && channelId > 0) {
            postListParams = Object.assign({}, postListParams, {
                channelId: channelId
            });
        }
        this.influencerService.getInfluencerPosts(influencerId, postListParams)
            .subscribe(function (data) {
            data.forEach(function (item) {
                item.title = item.title.replace(/\uFFFD/g, ''); // remove unknown character
                item.title = item.title.substring(0, 100) + '...'; // get 100 characters
            });
            data.sort(function (a, b) { return b.engagement - a.engagement; });
            _this.influencerPostList = channelId && channelId > 0 ? data : data.slice(0, CommonConstant.LIMIT_20);
            // if no posts, post list pdf module should be activated immediately
            if (_this.influencerPostList.length === 0) {
                _this.pdfExportService.incrementNumberReportReady(PostListComponent.COMPONENT_NAME);
            }
        }, function (error) { });
    };
    InfluencerDetailPdfViewerComponent.prototype.getPeformanceReportTimeLineChart = function (influencerId, channelId) {
        var _this = this;
        var dailyKpiParam = {
            period: CommonConstant.PERIOD_30_DAYS
        };
        if (channelId) {
            dailyKpiParam = Object.assign({}, dailyKpiParam, {
                channelId: channelId
            });
        }
        this.influencerService.getDailyKpiTimeLineChart(influencerId, dailyKpiParam).subscribe(function (res) {
            _this.influencerActivityLineChartData = res;
        });
    };
    InfluencerDetailPdfViewerComponent.prototype.getPlatformReachTable = function (influencerId, channelId) {
        var _this = this;
        var platformReachTableParams = {
            limit: LIMIT.LIMIT_10,
            period: CommonConstant.PERIOD_30_DAYS
        };
        if (channelId) {
            platformReachTableParams = Object.assign({}, platformReachTableParams, {
                channelId: channelId
            });
        }
        this.influencerService.getInfluencerPosts(influencerId, platformReachTableParams).subscribe(function (res) {
            _this.listPlatformReach = res;
        });
    };
    InfluencerDetailPdfViewerComponent.prototype.getExposures = function (influencerId, channelId) {
        var _this = this;
        var params = {
            period: CommonConstant.PERIOD_30_DAYS
        };
        if (channelId) {
            params = Object.assign({}, params, {
                channelId: channelId
            });
        }
        this.influencerService.getTopExposures(influencerId, params).subscribe(function (res) {
            _this.topExposures = [res.reach, res.engagement, res.impact];
        });
    };
    InfluencerDetailPdfViewerComponent.prototype.getBestPerforming = function (influencerId, channelId) {
        var _this = this;
        var bestPerformingParam = {
            period: CommonConstant.PERIOD_30_DAYS,
            limit: LIMIT.LIMIT_10
        };
        if (channelId) {
            bestPerformingParam = Object.assign({}, bestPerformingParam, {
                channelId: channelId
            });
        }
        this.influencerService.getBestPerforming(influencerId, bestPerformingParam).subscribe(function (res) {
            _this.bestPerformingExposures = res;
        });
    };
    Object.defineProperty(InfluencerDetailPdfViewerComponent.prototype, "logoImage", {
        get: function () {
            return this.userService.logoImage;
        },
        enumerable: true,
        configurable: true
    });
    InfluencerDetailPdfViewerComponent.prototype.getSelectedDemographicSource = function (evt) {
        this.selectedDemographicSource.name = evt.name;
        this.selectedDemographicSource.platformName = evt.platformName;
    };
    InfluencerDetailPdfViewerComponent.prototype.loadPieChartStyling = function () {
        this.pieChartHeight = pieChartConfig.pdfView.pieChartHeight;
        this.pieChartCenter = pieChartConfig.pdfView.pieChartCenter;
        this.pieChartSize = pieChartConfig.pdfView.pieChartSize;
        this.pieChartInnerSize = pieChartConfig.pdfView.pieChartInnerSize;
        this.pieChartTitleStyling = pieChartConfig.pdfView.pieChartTitleStyling;
        this.pieChartLegend = pieChartConfig.pdfView.pieChartLegend;
    };
    /**
  * get channel followers of influencer
  * @param influencerId
  * @param activeChannel
  */
    InfluencerDetailPdfViewerComponent.prototype.getChannelFollowers = function (influencerId, activeChannel) {
        var _this = this;
        this.influencerService.getChannelFollowerData(influencerId, activeChannel).subscribe(function (res) {
            if (res) {
                var data = _this.influencerService.calculateChannelFollower(res);
                _this.channelFollowersData = data.calculatedChannelFollower;
            }
        });
    };
    return InfluencerDetailPdfViewerComponent;
}());
export { InfluencerDetailPdfViewerComponent };



// WEBPACK FOOTER //
// ./src/app/main/pdf-viewer/influencer-detail-pdf-viewer/influencer-detail-pdf-viewer.component.ts.pre-build-optimizer.js